import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'otto-olsen-barcode-scanner-error-message-modal',
  templateUrl: './otto-olsen-barcode-scanner-error-message-modal.component.html',
  styleUrl: './otto-olsen-barcode-scanner-error-message-modal.component.scss',
  standalone: false
})
export class OttoOlsenBarcodeScannerErrorMessageModalComponent {
  /** Translation key for the modal title. */
  @Input()
  public titleKey: string;

  /** Translation key for the modal body message. */
  @Input()
  public messageKey: string;

  constructor(public activeModal: NgbActiveModal) {}
}
